/**
 * ノベルティ選択（一定金額以上で、指定商品のうち1点を無料で選べる）。
 * - select: 選んだバリアントを1点入れ、それまでのノベルティは外す（常に1点だけ）
 * - clear : ノベルティを外す
 * - sync  : Liquid が data-sync に出した updates（しきい値割れ・重複の修正）を自動で送る
 * いずれも /cart/update.js に sections を付けて投げ、テーマ標準の再描画フローに乗せる。
 *
 * xCartNoveltyGate: 表示開始日時（settings.novelty_start_at）より前に描画された HTML に置かれる。
 * 開始時刻を跨いだら（または開始後にキャッシュの古い HTML が表示されたら）カートのセクションを取り直す。
 */
if (!window.Eurus.loadedScript.includes('c-cart-novelty.js')) {
  window.Eurus.loadedScript.push('c-cart-novelty.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      // カートページではドロワーとカートページの両方に置かれるので、タイマーは window で1本にする
      const GATE_MAX_DELAY = 24 * 60 * 60 * 1000; // setTimeout の上限（約24.8日）を超えないよう1日ずつ待つ
      const GATE_RETRY_DELAY = 30 * 1000; // 端末の時計が進んでいて、取り直してもまだ開始前だった時の再試行間隔
      const GATE_MAX_TRIES = 10;

      Alpine.data('xCartNoveltyGate', ({ start = 0 } = {}) => ({
        init() {
          if (!start || window.cNoveltyGateTimer) return;
          const wait = start - Date.now();
          const tries = window.cNoveltyGateTries || 0;
          if (wait <= 0 && tries >= GATE_MAX_TRIES) return;
          const delay = wait > 0 ? Math.min(wait + 1000, GATE_MAX_DELAY) : tries === 0 ? 0 : GATE_RETRY_DELAY;

          window.cNoveltyGateTimer = setTimeout(() => {
            window.cNoveltyGateTimer = null;
            if (Date.now() < start) {
              // 1日ずつ待っている途中なので待ち直す
              this.init();
              return;
            }
            window.cNoveltyGateTries = (window.cNoveltyGateTries || 0) + 1;
            this.refresh();
          }, delay);
        },

        async refresh() {
          const sectionsToRender = Alpine.store('xCartHelper').getSectionsToRender();
          const ids = sectionsToRender.map((section) => section.id);
          try {
            const response = await fetch(`${window.location.pathname}?sections=${ids.join(',')}`, {
              credentials: 'same-origin'
            });
            if (!response.ok) return;
            const sections = await response.json();
            sectionsToRender.forEach((section) => {
              const sectionElement = document.querySelector(section.selector);
              if (sectionElement && sections[section.id]) {
                sectionElement.innerHTML = getSectionInnerHTML(sections[section.id], section.selector);
              }
            });
          } catch (error) {
            console.error('[c-cart-novelty]', error);
          }
        }
      }));

      Alpine.data('xCartNovelty', ({ currentIds = [], openId = null } = {}) => ({
        loading: null,
        error: '',
        currentIds: currentIds,
        openId: openId,

        select(variantId, productId) {
          if (this.currentIds.length === 1 && this.currentIds[0] === variantId) return;

          const updates = {};
          this.currentIds.forEach((id) => {
            updates[id] = 0;
          });
          updates[variantId] = 1;
          return this.updateCart(updates, productId);
        },

        clear() {
          const updates = {};
          this.currentIds.forEach((id) => {
            updates[id] = 0;
          });
          return this.updateCart(updates, 'clear');
        },

        // カートページではドロワーとカートページの両方にこのコンポーネントが居るので、同時に送らないようにする
        sync(el) {
          let updates = {};
          try {
            updates = JSON.parse(el.dataset.sync || '{}');
          } catch (error) {
            return;
          }
          if (Object.keys(updates).length === 0) return;
          if (window.cNoveltySyncing) return;

          window.cNoveltySyncing = true;
          this.updateCart(updates, 'sync').finally(() => {
            window.cNoveltySyncing = false;
          });
        },

        async updateCart(updates, loadingKey) {
          if (this.loading !== null) return;

          this.loading = loadingKey;
          this.error = '';

          const sectionsToRender = Alpine.store('xCartHelper').getSectionsToRender();

          try {
            const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify({
                updates: updates,
                sections: sectionsToRender.map((section) => section.id),
                sections_url: window.location.pathname
              })
            });

            const state = await response.json();

            if (!response.ok) {
              this.error = state.description || state.message || '';
              this.loading = null;
              return;
            }

            sectionsToRender.forEach((section) => {
              const sectionElement = document.querySelector(section.selector);
              if (sectionElement && state.sections && state.sections[section.id]) {
                sectionElement.innerHTML = getSectionInnerHTML(state.sections[section.id], section.selector);
              }
            });

            Alpine.store('xCartHelper').currentItemCount = state.item_count;
            document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));

            // 通常は再描画で自身が差し替わるが、差し替わらなかった場合に備えて戻す
            this.loading = null;
          } catch (error) {
            console.error('[c-cart-novelty]', error);
            this.loading = null;
          }
        }
      }));
    });
  });
}
